import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import FeedImportsComponent from '@app/components/apps/FeedImport/FeedImport';

const AddFeedImport = () => {
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Feed Import');

  const routes = [
    { path: '/feed-imports', breadcrumbName: 'Feed Importation' },
    { path: '/add-feed-import', breadcrumbName: 'Add Feed Import' },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <FeedImportsComponent
          editable={true}
          pageTitle={'Add Feed Import'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default AddFeedImport;
